// src/pages/ExamsFinish.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const authHeader = () => ({ Authorization: `Bearer ${localStorage.getItem('token') || ''}` });

function fmt(dt){
    try { return new Intl.DateTimeFormat('pl-PL',{dateStyle:'medium', timeStyle:'short'}).format(new Date(dt)); }
    catch { return dt || '—'; }
}
function mapStatus(s){
    const m = {
        created: 'Utworzony',
        pending_verification: 'Weryfikacja',
        in_progress: 'W trakcie',
        submitted: 'Złożony',
        awaiting_manual: 'Oczekuje na ocenę',
        auto_graded: 'Oceniony automatycznie',
        completed: 'Zakończony',
        canceled: 'Unieważniony',
    };
    return m[s] || s || '—';
}

export default function StudentPastTerms(){
    const nav = useNavigate();
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState('');
    const [terms, setTerms] = useState([]);
    const [guestTerms, setGuestTerms] = useState([]);

    useEffect(()=>{
        let cancelled=false;
        (async()=>{
            setLoading(true); setErr('');
            try{
                const [r1, r2] = await Promise.all([
                    fetch(`/api/student/terminy/zakonczone`,             { credentials:'include', headers:{ ...authHeader() } }),
                    fetch(`/api/student/terminy/kod/zakonczone`,         { credentials:'include', headers:{ ...authHeader() } }),
                ]);
                const j1 = r1.ok ? await r1.json() : [];
                const j2 = r2.ok ? await r2.json() : [];
                if (!cancelled){
                    setTerms(Array.isArray(j1) ? j1 : []);
                    setGuestTerms(Array.isArray(j2) ? j2 : []);
                }
            }catch(e){
                if (!cancelled) setErr(e.message || 'Błąd pobierania');
            }finally{
                if (!cancelled) setLoading(false);
            }
        })();
        return ()=>{ cancelled=true; };
    }, []);

    return (
        <div style={{ maxWidth: 1000, padding:'0 16px', marginTop:80 }}>
            <h1 style={{marginBottom:'20px'}}>Zakończone terminy</h1>
            <hr />

            <h2 style={{ margin:'12px 0' }}>Twoje terminy (grupy)</h2>
            {loading ? (
                <div>Ładowanie…</div>
            ) : err ? (
                <div style={{ color:'crimson' }}>{err}</div>
            ) : terms.length === 0 ? (
                <div style={{ border:'1px dashed #d1d5db', borderRadius:12, padding:20, color:'#6b7280' }}>
                    Brak zakończonych terminów.
                </div>
            ) : (
                <div style={{ display:'grid', gap:12 }}>
                    {terms.map(t => {
                        const hasAttempt = !!t.attempt_id;
                        const status = t.attempt_status || null;
                        return (
                            <div key={t.term_id}
                                 style={{ border:'1px solid #e5e7eb', borderRadius:12, padding:14, background:'#fff',
                                     display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:12 }}>
                                <div>
                                    <div style={{ fontWeight:700 }}>{t.title || 'Egzamin'}</div>
                                    <div style={{ color:'#6b7280', fontSize:14 }}>
                                        {fmt(t.exam_datetime)} • {t.exam_duration} min • Proctoring: {t.proctoring?'tak':'nie'}
                                        {hasAttempt ? <> • Status: {mapStatus(status)}</> : null}
                                    </div>
                                </div>
                                <div>
                                    {hasAttempt ? (
                                        <button className={'but-smal'}
                                                onClick={()=> nav(`/student/egzamin/${t.attempt_id}/wyniki`)}
                                                style={{ padding:'8px 12px' }}>
                                            Wyniki
                                        </button>
                                    ) : (
                                        <span style={{ color:'#6b7280' }}>Brak udziału</span>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}

            <h2 style={{ margin:'20px 0 12px' }}>Dołączono za pomocą kodu</h2>
            {loading ? (
                <div>Ładowanie…</div>
            ) : guestTerms.length === 0 ? (
                <div style={{ border:'1px dashed #d1d5db', borderRadius:12, padding:20, color:'#6b7280' }}>
                    Brak zakończonych egzaminów dołączonych kodem.
                </div>
            ) : (
                <div style={{ display:'grid', gap:12 }}>
                    {guestTerms.map(t => (
                        <div key={t.attempt_id}
                             style={{ border:'1px solid #e5e7eb', borderRadius:12, padding:14, background:'#fff',
                                 display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:12 }}>
                            <div>
                                <div style={{ fontWeight:700 }}>{t.title || 'Egzamin'}</div>
                                <div style={{ color:'#6b7280', fontSize:14 }}>
                                    {fmt(t.exam_datetime)} • {t.exam_duration} min • Proctoring: {t.proctoring?'tak':'nie'}
                                    {' '}• Status: {mapStatus(t.attempt_status)}
                                </div>
                            </div>
                            <button className={'but-smal'}
                                    onClick={()=> nav(`/student/egzamin/${t.attempt_id}/wyniki`)}
                                    style={{ padding:'8px 12px' }}>
                                Wyniki
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
